import React from 'react';
import ConfirmDialog from './ConfirmDialog';
import { useTranslation } from 'react-i18next';
import { useCountdownTimer } from '../../utils/date';
import { remindMeLater, scheduleUpdate, useAppStatus } from '../app/appStatus';

/**
 * Displays dialog that prompts user to apply update. Displays auto update countdown and allows user to snooze the update
 * @constructor
 */
const UpdateDialog = () => {
  const { t } = useTranslation();
  const { updatePromptOpen, autoUpdateTime } = useAppStatus();
  const countdown = useCountdownTimer(autoUpdateTime);
  return (
    <ConfirmDialog
      title={t('updateAvailable')}
      message={t('reloadApplicationToApplyUpdate', { countdown })}
      open={updatePromptOpen}
      onConfirm={() => scheduleUpdate()}
      onCancel={remindMeLater}
      cancelLabel={t('remindMeLater')}
      confirmLabel={t('reloadNow')}
      // A stray tap shouldn't silently snooze the update for an hour (Bug 61855)
      disableDismiss
    />
  );
};

export default UpdateDialog;
